<template>
    <div class="position-box">
        <div class="head">
            <div class="title" v-if="token">
              <img class="icon" @click="leftMask" :src="homeLogo" alt="">
              <div class="text" v-show="isMn">{{$t('langNew2.mnzh')}}</div>
              <div class="text" v-show="!isMn">{{$t('langNew2.zczgz')}}</div>
              <div class="text2" v-show="!isKyZcShow"><span v-if="isMn">{{bb_usdt | balance}}</span><span v-else>{{bb_usdt | balance}}</span> USDC</div>
              <div class="text2" v-show="isKyZcShow">****** USDC</div>
              <img class="eyes" v-show="!isKyZcShow" @click="change" src="@/assets/user/zhenyan.png" alt="">
              <img class="eyes" v-show="isKyZcShow" @click="change" src="@/assets/user/biyan.png" alt="">
            </div>
            <div v-else class="login" @click="login">{{$t('langNew5.dl')}}</div>
            <div class="lang" @click="rightMask"><img class="icon" src="@/assets/new2/gengduo.png" alt=""></div>
        </div>
        <div class="cont-box" @click="listenScroll">
            <div class="banner-wrap" v-show="bannerList.length > 0">
              <swiper class="banner-box swiper" ref="mySwiper" :options="swiperOption">
                <swiper-slide class="banner" v-for="(item,index) in bannerList" :key="index"><img class="img" :src="item.url" alt="banner"></swiper-slide>
                <div class="swiper-pagination"  slot="pagination"></div>
              </swiper>
            </div>
            <div class="notice-box" v-show="noticeList && noticeList.length > 0">
                <img class="icon" src="@/assets/new/notice.png" alt="">
                <ul class="notice">
                    <swiper class="swiper" ref="mySwipers" :options="swiperOption2">
                        <swiper-slide class="text" v-for="(item,index) in noticeList" :key="index">{{item.title}}</swiper-slide>
                    </swiper>
                </ul>
                <img class="arrow" src="@/assets/arrow-white.png" alt="">
            </div>
            <ul class="coin-box">
              <li class="coin-li" v-for="(item, index) in listData" :key="index" @click="jump2(item.symbol)">
                <div class="coin-head">
                    <img class="icon" v-if="item.type == 1" :src="item.icon" alt="">
                    <div class="text">{{item.name | rewriteName}}/<span class="t1">USDC</span></div>
                </div>
                <div class="price">{{item.new_price || 0.00 | toFixed4}}</div>
                <div class="change" :class="{red: item.grow < 0}"><img v-if="item.grow < 0" class="arrow die" src="@/assets/arrow_icon_red.png" alt=""><img v-else class="arrow" src="@/assets/arrow_icon.png" alt="">{{item.grow || 0.00 }}%</div>
              </li>
            </ul>
            <ul class="item-wrap">
              <router-link class="item-box" tag="li" to="/loan">
                <img class="img" src="@/assets/new2/AI.png" alt="">
                <div class="text">{{$t('langNew2.zb')}}</div>
              </router-link>
              <router-link class="item-box" tag="li" to="/contractTransaction">
                <img class="img" src="@/assets/new/jiaoge.png" alt="">
                <div class="text">{{$t('langNew.jghy')}}</div>
              </router-link>
              <router-link class="item-box" tag="li" to="/currencyTrading">
                <img class="img" src="@/assets/new/duihuan.png" alt="">
                <div class="text">{{$t('langNew4.jy')}}</div>
              </router-link>
              <router-link class="item-box" tag="li" to="/c2c">
                <img class="img" src="@/assets/new2/C2C.png" alt="">
                <div class="text">{{$t('c2c.bt')}}</div>
              </router-link>
              <router-link class="item-box" tag="li" to="/videos">
                <img class="img" src="@/assets/new3/zhanghujilu.png" alt="">
                <div class="text">{{$t('c2c.sp')}}</div>
              </router-link>
              <router-link class="item-box" tag="li" to="/credit">
                <img class="img" src="@/assets/new/qiandao.png" alt="">
                <div class="text">{{$t('xyf.title')}}</div>
              </router-link>
              <li class="item-box" v-if="!isMn" @click="create">
                <img class="img" src="@/assets/new2/moni.png" alt="">
                <div class="text">{{$t('langNew2.mnjy')}}</div>
              </li>
              <li class="item-box" v-else @click="exit">
                <img class="img" src="@/assets/new2/moni.png" alt="">
                <div class="text">{{$t('langNew2.tcmnzh')}}</div>
              </li>
              <router-link class="item-box" tag="li" to="/onlineService">
                <img class="img" src="@/assets/new/zaixiankefu.png" alt="">
                <div class="text">{{$t('langNew.zxkf')}}</div>
              </router-link>
            </ul>
            <ul class="tab-box2">
              <li class="tab2" :class="{active: bzType == 1}" @click="tab2(1)">{{$t('langNew4.szhb')}}</li>
              <li class="tab2" :class="{active: bzType == 6}" @click="tab2(6)">{{$t('langNew4.gp')}}</li>
            </ul>
            <ul class="table-head">
                <li class="th">{{$t('langNew.mc')}}</li>
                <li class="th text-center">{{$t('langNew.zxj')}}</li>
                <li class="th text-right">{{$t('langNew.zfb')}}</li>
            </ul>
            <ul class="table-body">
              <li class="tr" v-for="(item, index) in listData" :key="index" @click="jump2(item.symbol)">
                <div class="item coin">
                    <img class="icon" v-if="item.type == 1" :src="item.icon" alt="">
                    <div class="t1">{{item.name | rewriteName}}/<span class="t2">USDC</span></div>
                </div>
                <div class="item price text-center">{{item.new_price || 0.00 | toFixed4}}</div>
                <div class="item change text-right"><span class="persent" :class="{'bg-red': item.grow < 0}">{{item.grow || 0.000 | toFixed2}}%</span></div>
              </li>
            </ul>
            <no-data v-show="hasData"></no-data>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
        <loading v-show="isLoad"></loading>
        <div class="mask" v-show="isPwd"></div>
        <div class="alert-box" v-show="isPwd">
            <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
            <img class="close" src="@/assets/close.png" @click="close" alt="">
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
            </ul>
        </div>
        <!-- 公告弹窗 -->
        <div class="mask-notice" v-show="isNotice">
          <div class="notice-wrap">
              <div class="title">{{$t('langNew.gg')}}</div>
              <div class="cont" v-html="noticeHtml"></div>
              <div class="notice-btn btn-bg" @click="goDetail">{{$t('kxt.djck')}}</div>
              <img class="btn-close" @click="noticeClose" src="@/assets/close.png" alt="">
          </div>
        </div>
        <div class="mask" v-show="isMask" @click="closeAlert"></div>
        <!-- 右侧弹窗 -->
        <div class="alert-right-mask" v-show="isRightMask">
          <img class="close" src="@/assets/close.png" @click="closeAlert" alt="">
          <ul class="alert-item-ul">
            <li tag="li" class="alert-li" @click="goHome">
              <div class="title">{{$t('langNew.shouye')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </li>
            <li class="alert-li" @click="goRz">
              <div class="title">{{$t('langNew.jdrz')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </li>
            <router-link tag="li" class="alert-li" to="/loan">
              <div class="title">{{$t('langNew2.zb')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/benefits">
              <div class="title">{{$t('langNew2.flzq')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/currency">
              <div class="title">{{$t('langNew.wyjb')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/taxSubsidies">
              <div class="title">{{$t('ssbt.ssbt')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <li class="alert-li" @click="create">
              <div class="title">{{$t('langNew2.mnjy')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </li>
            <router-link tag="li" class="alert-li" to="/lang">
              <div class="title">{{$t('langNew.yyqh')}}</div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <li class="alert-li alert-li2" v-show="token" @click="exit2">
              <div class="title">{{$t('newReg.dc')}}</div>
            </li>
          </ul>
        </div>
        <!-- 左侧弹窗 -->
        <div class="alert-left-mask" v-show="isLeftMask">
          <img class="close" src="@/assets/close.png" @click="closeAlert" alt="">
          <div class="alert-head">
            <img class="user" :src="homeLogo" alt="">
            <div class="address-box">
              <div class="address">{{address | mdName}}</div>
              <div class="uid" v-show="userID">UID: {{userID}}</div>
            </div>
            <img class="copy" @click="copy($event)" src="@/assets/new2/copy.png" alt="">
          </div>
          <ul class="alert-item-ul">
            <router-link tag="li" class="alert-li" v-show="!isMn" to="/myAssets">
              <div class="title">
                <img class="icon" src="@/assets/new2/wdzh.png" alt="">
                <div class="text">{{$t('langNew2.wdzh')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" v-show="isMn" to="/myAssets">
              <div class="title">
                <img class="icon" src="@/assets/new2/wdzh.png" alt="">
                <div class="text">{{$t('langNew2.mnzh')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/deposit">
              <div class="title">
                <img class="icon" src="@/assets/new2/chongbi.png" alt="">
                <div class="text">{{$t('chongbi.title')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/withdraw">
              <div class="title">
                <img class="icon" src="@/assets/new2/tibi.png" alt="">
                <div class="text">{{$t('usdttb.title')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/accountRecords">
              <div class="title">
                <img class="icon" src="@/assets/new2/jilu.png" alt="">
                <div class="text">{{$t('zhjl.title')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
            <router-link tag="li" class="alert-li" to="/onlineService">
              <div class="title">
                <img class="icon" src="@/assets/new2/kefu1.png" alt="">
                <div class="text">{{$t('langNew.zxkf')}}</div>
              </div>
              <img class="arrow" src="@/assets/more2.png" alt="">
            </router-link>
          </ul>
        </div>
        <!-- 登录弹窗 -->
        <div class="mask" v-show="isLogin"></div>
        <div class="alert-login-box" v-show="isLogin">
          <div class="alert-head-box">
            <img class="logo" :src="homeLogo" alt="">
            <div class="alert-head">
              <div class="alert-title">{{webTitle}}</div>
              <div class="alert-url">{{shareUrl}}</div>
            </div>
          </div>
          <div class="alert-tips">{{$t('langNew5.ljdz')}}</div>
          <div class="input-box"><input class="input" type="text" v-model="address" :placeholder="$t('langNew5.srdz')"></div>
          <div class="alert-btn-box">
            <div class="alert-btn btn-jj" @click="close">{{$t('langNew5.jj')}}</div>
            <div class="alert-btn btn-lj" @click="sure">{{$t('langNew5.lj')}}</div>
          </div>
        </div>
        <!-- 链接弹窗 -->
        <div class="mask" v-show="isLink"></div>
        <div class="alert-login-box" v-show="isLink">
          <div class="alert-head-box">
            <img class="logo" :src="homeLogo" alt="">
            <div class="alert-head">
              <div class="alert-title">{{webTitle}}</div>
              <div class="alert-url">{{shareUrl}}</div>
            </div>
          </div>
          <div class="alert-tips">{{$t('langNew5.ljqq')}}</div>
          <ul class="alert-ul-box alert-ul-box2">
            <li class="alert-li">
              <img class="icon" src="@/assets/new3/tx.png" alt="">
              <div>
                <div class="t1">{{$t('langNew5.qq')}}</div>
                <div class="t2">{{$t('langNew5.qb')}} 1</div>
              </div>
            </li>
          </ul>
          <ul class="alert-ul-box">
            <li class="alert-li">
              <img class="icon" src="@/assets/new3/gantan.png" alt="">
              <div>
                <div class="t1">{{$t('langNew5.qq')}}</div>
                <div class="t2">·{{$t('langNew5.ckyehhd')}}</div>
                <div class="t2">·{{$t('langNew5.qqjypz')}}</div>
              </div>
            </li>
            <li class="alert-li">
              <img class="icon" src="@/assets/new3/lianjie.png" alt="">
              <div>
                <div class="t1">{{$t('langNew5.qq')}}</div>
                <div class="t2">
                  <img class="img" src="@/assets/new3/cro.png" alt="">
                  <div>{{$t('langNew5.cro')}}</div>
                </div>
              </div>
            </li>
          </ul>
          <div class="alert-btn-box">
            <div class="alert-btn btn-jj" @click="close">{{$t('langNew5.jj')}}</div>
            <div class="alert-btn btn-lj" @click="sure2">{{$t('langNew5.lj')}}</div>
          </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
import loading from '@/components/loading.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
let that = this;
let vm = null;
export default {
    name: 'index',
    data () {
      return {
          lang: 'en',
          tabIdx: 1,
          uid: '',
          token: '',
          bannerList: [],
          noticeList: [],
          profitData: {},
          listData: [],
          isSmrz: false,
          isShowSmrz: false,
          isShow: false,
          issHShow: false,
          isMask: false,
          isDate: false,
          isLoad: false,
          mm_id: '',
          hasData: false,
          hasData2: false,
          isDownLoad: '',
          cont: '',
          isReset: false,
          startTime: '',
          startTimes: '',
          endTimes: '',
          startDate: '',
          selectedValue: '',
          endDate:'',
          endTime:'',
          cancelText: '',
          confirmText: '',
          isGoTOP: false,
          curDataLength: 10,
          page: 1,
          limit: 10,
          timer: null,
          address: '',
          ether_eth: 0,
          ether_usdt: 0,
          bb_usdt: 0,
          timestamp: 0,
          orderId: '',
          isPwd: false,
          inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
          isNotice: false,
          noticeHtml: '',
          isNoticeShow: '',
          ether_jdrz: 0,
          swiperOption: {
              notNextTick: true,
              loop:true,
              autoplay:{
  　　　　　　　　delay: 4000,
  　　　　　　　　stopOnLastSlide: false,
  　　　　　　　　/* 触摸滑动后是否继续轮播 */
  　　　　　　　　disableOnInteraction: false
  　　　　　　},
              pagination: {
                  el: '.swiper-pagination',
                  clickable :true,
              },
              on:{
                  click: ()=>{
                      let swiper1 = this.$refs.mySwiper.$swiper;
                      let i = swiper1.realIndex;
                      vm.bannerLink(i);
                  }
              }
          },
          swiperOption2: {
              notNextTick: true,
              loop: true,
              direction: "vertical",
              autoplay:{
  　　　　　　　　delay: 4000,    　　　　　　　　
　　　　　　     },
              on:{
                  click: ()=>{
                      let swiper = this.$refs.mySwipers.$swiper;
                      let i = swiper.realIndex;
                      vm.goNotice(i);
                  }
              },
          },
          userID: '',
          isMask: false,
          isRightMask: false,
          isLeftMask: false,
          isApprove: true,
          isMn: false,
          userInfo: {},
          bzType: 1,
          isKyZcShow: false,
          isLogin: false,//登录弹窗
          isLink: false,//链接弹窗
          shareUrl: '',
          ethTime: 0
      }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      vm = this;
      this.lang = localStorage.getItem('user_lang');
      this.token = localStorage.getItem('token');
      this.address = localStorage.getItem('ethAddress');
      this.userID = localStorage.getItem('userID');
      this.timestamp = localStorage.getItem('timestamp') || 0;
      this.isMn = JSON.parse(sessionStorage.getItem('isMn'));
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let kyZcShow = localStorage.getItem('kyZcShow');
      if(kyZcShow == null || kyZcShow == 'false'){
        localStorage.setItem('kyZcShow',false);
        this.isKyZcShow = false
      }else{
        localStorage.setItem('kyZcShow',true);
        this.isKyZcShow = true
      }
      this.bb_usdt = localStorage.getItem('bbUsdt') || 0;
    },
    mounted() {
      this.getAddress();
      this.shareUrl = window.location.host;
      this.isNoticeShow = sessionStorage.getItem('isNoticeShow');
      if(this.isMn && this.userInfo){
        this.userID = this.userInfo.id;
        this.getAsset();
      }else{

      }
      this.getBanner();
      this.getGG();
      this.getInfo();
      this.getmarketList();
      this.initWebSocket();
    },
    methods: {
      goHome(){
        this.isMask = this.isRightMask = false;
      },
      leftMask(){
        this.isMask = this.isLeftMask = true;
      },
      rightMask(){
        this.isMask = this.isRightMask = true;
      },
      closeAlert(){
        this.isMask = this.isRightMask = this.isLeftMask = false;
      },
      change(){
        this.isKyZcShow = !this.isKyZcShow;
        localStorage.setItem('kyZcShow',this.isKyZcShow)
      },
      goApprove(){
        window.location.href = this.sqHost + "/approve.html"
      },
      copy(e){
        let address = this.address;
        this.$copyText(address, this.$t('chongbi.fzcg'));
        this.$toast.center(this.$t('chongbi.fzcg'));
      },
      login(){
        this.isLogin = true;
      },
      create(){
        if(JSON.parse(sessionStorage.getItem('isMn'))){
          this.$toast.center(this.$t('langNew2.yymnzhts'));
          return ;
        }
        let params = {
          address: this.address
        }
        this.$ajax.post('/web/tempLogin',params).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.isRightMask = false;
            this.isMask = false;
            this.token = resData.token;
            this.bb_usdt = resData.bb_usdt;
            this.ether_eth = resData.ether_eth;
            this.ether_usdt = resData.ether_usdt;
            this.userID = resData.id;
            localStorage.setItem('userInfo',JSON.stringify(resData));
            localStorage.setItem('token',resData.token);
            sessionStorage.setItem('isMn',true)
            this.$toast.center(this.$t('langNew2.cjmnzhcg'));
            var url = window.location.protocol + '//' + window.location.host;
            window.location.href = url;
          }else{
            this.$toast.center(res.data.message);
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getAsset(){
        let that = this;
        let params = {
          id: 1
        }
        this.$ajax.get('/web/getAsset2',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              setTimeout(()=>{
                this.$router.push('/index');
              },1000)
              return false
            }
            that.bb_usdt =  resData.totalMoney;
        }).catch(function(err){
            console.log(err)
        })
      },
      exit(){
        this.bb_usdt = 0;
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        sessionStorage.removeItem('isMn');
        localStorage.removeItem('ethAddress');
        localStorage.removeItem('userID');
        var url = window.location.protocol + '//' + window.location.host;
        window.location.href = url;
      },
      bannerLink(i){
        let id = this.bannerList[i].id;
        let content = this.bannerList[i].content;
        if(id){
            if(this.filterHtmlTag(content)){
                this.$router.push({path: "/bannerDetail",query: { id }});
            }
        }
      },
      getEthTime(){//获取时间
        let params = {
          address: this.address
        }
        this.$ajax.get('/web/ethTime',{params}).then((res) => {
          if(res.data.code == 0){
            this.ethTime = res.data.data;
            this.getEthLogin();
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getInfo(){
        this.$ajax.post('/web/info').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.ether_jdrz = resData.ether_jdrz || 0;
          }else{
            this.$router.push('/index');
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      goRz(){
        if(this.ether_jdrz == 2){
           this.$toast.center(this.$t('langNew.yrz'));
        }else{
          this.$router.push('/nodeAuth?address=' + this.address);
        }
      },
      tab(idx){
        this.tabIdx = idx;
        this.page = 1;
        this.listData = [];
        this.getmarketList();
      },
      tab2(id){
        this.bzType = id;
        this.listData = [];
        this.currencyList = [];
        this.getmarketList();
      },
        goNotice(idx){
          let id = this.noticeList[idx].id;
          this.$router.push({path: "/notice",query: { id: id }});
        },
        goDetail(){
          this.$router.push({path: "/notice",query: { id: this.noticeId }});
        },
        jump(){
          this.$router.push('/myAssets')
        },
        jump2(symbol){
          if(this.bzType == 1){
           this.$router.push({ path: '/contractTransaction', query: { symbol: symbol } })
         }else{
           this.$router.push({ path: '/contractTransaction2', query: { symbol: symbol } })
         }
        },
        noticeClose(){
          if(this.isNoticeShow != null){
            this.isNotice = true;
            sessionStorage.removeItem('isNoticeShow');
          }else{
            this.isNotice = false;
            sessionStorage.setItem('isNoticeShow',true);
          }
        },
        getBanner(){
		  	  let params = {
            token:1,
          }
          this.$ajax.get('/web/getBanner',{params}).then((res) => {
              let resData = res.data.data;
              this.bannerList = resData;

          }).catch(function(err){
              console.log(err)
          })
        },
        getGG(id){
            this.$ajax.get('/web/getGG').then((res) => {
              var noticeArr = [];
              let resData = res.data.data;
              this.noticeList = resData;
              if(resData && resData.length > 0){
                noticeArr = resData.filter((item,index) =>{
                if(item.is_popover == 1){
                  return true;
                }else{
                  return ''
                }
              });
              if(noticeArr.length > 0){
                if(this.isNoticeShow){
                  this.isNotice = false;
                }else{
                  this.isNotice = true;
                }
                this.noticeId = noticeArr[0].id;
                this.getNotice(this.noticeId);
              }
              }else{
                  this.isNotice = false
              }
          }).catch(function(err){
              console.log(err)
          })
		  },
      getNotice(id){
      let params = {
          id:id
        }
        this.$ajax.get('/web/getText',{params}).then((res) => {
            let resData = res.data.data;
            this.noticeHtml = this.contHtml(resData.content);
        }).catch(function(err){
            console.log(err)
        })
      },
      async getAddress() {
        var that = this;
        let web3Provider = null;
        if (window.ethereum) {
          web3Provider = window.ethereum;
          try {
            await window.ethereum.request({ method: "eth_requestAccounts" });
          } catch (error) {
            console.error("User denied account access");
            return false;
          }
        } else if (window.web3) {
          web3Provider = window.web3.currentProvider;
        } else {
          web3Provider = new Web3.providers.HttpProvider(that.adsHOST);
        }
        if (web3Provider) {
          const Web3address = new Web3(web3Provider);
          try {
            const accounts = await Web3address.eth.getAccounts();
            const address = accounts[0];
            if (address) {
              that.address = address;
              localStorage.setItem("ethAddress", address);
              that.getEthTime();
              that.getIsApprove();
            } else {
              if(!that.isInnerUser){
                that.$toast.center(that.$t("langNew2.ljdzsb"));
              }
            }
          } catch (error) {
            if(!that.isInnerUser){
              that.$toast.center(that.$t("langNew2.ljdzsb"));
            }
          }
        } else {
          if(!that.isInnerUser){
            that.$toast.center(that.$t("langNew2.ljdzsb"));
          }
        }
      },
      getIsApprove(){
        let params = {
          address: this.address
        }
        this.$ajax.get('/web/isApprove',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.isApprove = resData; //-1 未授权 1 授权
            if(resData == -1){
              this.isApprove = true
            }else{
              this.isApprove = false
            }
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getEthLogin(){//获取地址
        var str = this.address;
        var back6 = str.substring(str.length - 6);
        var sign = this.$sha1(str+this.ethTime+back6);
        let params = {
            address: this.address,
            t: this.ethTime,
            sign: sign
        }
        this.$ajax.get('/web/ethLogin',{params}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            localStorage.setItem('ethAddress',this.address);
            this.isLogin = false;
            this.isLink = false;
            if(this.isMn) return;
            this.token = resData.token;
            this.bb_usdt = resData.bb_usdt;
            this.ether_eth = resData.ether_eth;
            this.ether_usdt = resData.ether_usdt;
            this.userID = resData.id;
            localStorage.setItem('userID',resData.id);
            localStorage.setItem('token',resData.token);
            localStorage.setItem('bbUsdt',resData.bb_usdt);
          }else{
            this.$toast.center(res.data.message);
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getEthBalance(){//获取余额
          let params = {
            address: this.address
          }
          this.$ajax.post('/web/getEthBalance',params).then((res) => {
              if(res.data.code == 0){
                  this.ether_eth = res.data.data
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      getUsdtBalance(){//获取余额
          let params = {
            address: this.address
          }
          this.$ajax.post('/web/getUsdtBalance',params).then((res) => {
              if(res.data.code == 0){
                  this.ether_usdt = res.data.data
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      getTotal(){//收益统计
          this.$ajax.post('/web/getTotal').then((res) => {
              if(res.data.code == 0){
                  this.profitData = res.data.data;
              }else{
                  this.$router.push('/index')
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      initWebSocket(){ //初始化weosocket
          const wsuri = this.socket_url;
          this.websock = new WebSocket(wsuri);
          this.websock.onmessage = this.websocketonmessage;
          this.websock.onopen = this.websocketonopen;
          this.websock.onerror = this.websocketonerror;
          this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
      },
      websocketonerror(){//连接建立失败重连
          this.initWebSocket();
      },
      websocketonmessage(e){ //数据接收
        let msg = JSON.parse(e.data).content;
        if(JSON.parse(e.data).action == "marketprice"){
          let keyArr = [];
          for(var x in this.currencyList){
            for(var y in this.listData){
              x = this.bzType == 1 ? x.toLowerCase() : x;
              if(!msg[x]) return;
              if(msg[x].currency_name == this.listData[y].currency_name){
                this.listData[y]['new_price'] = msg[x].now_price;
                this.listData[y]['grow'] = msg[x].change;
                keyArr.push(this.listData[y]);
                break;
              }
            }
          }
          this.listData = keyArr;
        }
      },
      websocketsend(Data){//数据发送
          this.websock.send(Data);
      },
      websocketclose(e){  //关闭
          // console.log('断开连接',e);
      },
      getmarketList() {
        var that = this;
        let params = {
            token: '',
            id: 1,
            classify: 0,
            type: this.bzType,
        }
        that.isLoad = true;
        this.$ajax.get('/web/getmarketList',{params}).then((res) => {
          let resData = res.data.data;
          var curr;
          that.listData = resData;
          that.currencyList = [];
          for (curr in that.listData){
            that.currencyList[that.listData[curr].currency] = [that.listData[curr].icon,that.listData[curr].symbol];
          }
          that.isLoad = false;
        }).catch(function(err){
            console.log(err)
        })
      },
      nextFocus(el,index) {
          var dom = document.getElementsByClassName("pwd-input"),
              currInput = dom[index],
              nextInput = dom[index + 1],
              lastInput = dom[index - 1];
          /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
          if (el.keyCode != 8) {
              if (index < (this.inputList.length - 1)) {
                  nextInput.focus();
              } else {
                  currInput.blur();
              }
          }else{
              if (index != 0) {
                  lastInput.focus();
              }
          }
          let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
          if(password.length == 6){
              let params = {
                id: this.orderId,
                tpassword: password
              }
              this.$ajax.post('/web/sellProfit ',params).then((res) => {
                let resData = res.data.data.data;
                if(res.data.code == 0){
                    this.page = 1;
                    this.listData = [];
                    this.isPwd = false;
                    this.$toast.center(this.$t('status.statusText')[2]);
                    this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    this.getmarketList();
                }else{
                    this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    this.$toast.center(res.data.message);
                }
            }).catch(function(err){
                console.log(err);
            })
          }else{
              return false;
          }
      },
      sure(){
        if(this.address == '' || this.address == null){
          this.$toast.center(this.$t('langNew5.srdz'));
          return false;
        }
        this.isLink = true;
      },
      sure2(){
        this.getEthTime();
      },
      close(){
        this.isLogin = this.isLink = false;
        this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
        this.isPwd = false;
      },
      listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isGoTOP = true
          }else{
              this.isGoTOP = false
          }
      },
      goTop(){
        $('.cont-box').animate({scrollTop:'0px'},'slow');
      },
      alert(cont){
          this.isMask = true;
          this.issHShow = true;
          this.cont = cont;
      },
      cancle(){
          this.isReset = true;
          this.selectedValue = '';
          this.startTime = '';
          this.endTime = '';
      },
      sign(){
          this.$router.push('/sign');
      },
      contHtml(str){
          str = str.replace(/&amp;/g, '&');
          str = str.replace(/&lt;/g, '<');
          str = str.replace(/&gt;/g, '>');
          str = str.replace(/&quot;/g, "''");
          str = str.replace(/&#039;/g, "'");
          return str;
      },
      filterHtmlTag(msg){
        var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
        msg = msg.replace(/[|]*\n/, '') //去除行尾空格
        msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
        return msg;
      },
      exit2(){
        localStorage.removeItem('userInfo');
        localStorage.removeItem('token');
        localStorage.removeItem('isInnerUser');
        sessionStorage.setItem('isMn',false);
        localStorage.removeItem('ethAddress');
        localStorage.removeItem('userID');
        var url = window.location.protocol + '//' + window.location.host;
        window.location.href = url;
      },
    },
    watch: {
        startTime: function(val){
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.startTime = ''
                }else{
                    if(this.isReset){
                        this.startTime = ''
                    }else{
                        this.startTime = this.formatDate(val)
                    }
                }
            }else{
                 this.startTime = ''
            }
        },
        endTime: function(val){
            if(val != 'Invalid Date'){
                if(val == ''){
                    this.endTime = ''
                }else{
                    if(this.isReset){
                        this.endTime = ''
                    }else{
                        this.endTime = this.formatDate(val)
                    }
                }
            }else{
                 this.endTime = ''
            }
        }
    },
    filters: {
        statusText: (val) => {
            if(val == 0){
                return that.wkz
            }else if(val == 1){
                return that.wkwc
            }else{
                return that.wkz
            }
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + " " + h + m + s;
        }
    },
    components:{
        navBar,
        noData,
        VueBetterScroll,
        loading,
        Swiper,
        SwiperSlide,
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #fff;
        font-size: .42rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .24rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .36rem;
        line-height: .8rem;
        box-sizing: border-box;
    }
    .head .title{
      display: flex;
      align-items: center;
      height: .72rem;
      margin: .3rem 0;
      padding: .18rem .6rem .18rem 0;
      box-sizing: border-box;
    }
    .head .title .icon{
      width: .8rem;
      height: .8rem;
      border-radius: 50%;
    }
    .head .title .text{
      padding-left: .1rem;
      color: #fff;
      font-size: .42rem;
      font-weight: bold;
    }
    .head .title .text2{
      padding-left: .24rem;
      color: #fff;
      font-size: .38rem;
    }
    .head .login{
      position: absolute;
      left: .44rem;
      top: 50%;
      height: .78rem;
      color: #fff;
      font-size: .3rem;
      padding: 0 .8rem;
      line-height: .78rem;
      background: #0060ff;
      border-radius: 0.15rem;
      transform: translateY(-50%);
    }
    .head .lang{
      position: absolute;
      right: .3rem;
      top: 50%;
      transform: translateY(-50%);
    }
    .head .lang .icon{
      width: .5rem;
    }
    .head .eyes{
      width: .8rem;
      margin-left: .2rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.5rem;
        bottom: .2rem;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .24rem;
        overflow-y: scroll;
    }
    .cont-box .item-wrap{
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      flex-wrap: wrap;
      padding: .5rem;
    }
    .cont-box .item-wrap .item-box{
      width: 25%;
      margin-bottom: .2rem;
      text-align: center;
    }
    .cont-box .item-wrap .img{
      width: 1.25rem;
    }
    .cont-box .item-wrap .text{
      padding-top: .14rem;
      color: #fff;
      font-size: .36rem;
    }
    .sy-wrap{
        position: relative;
        padding: 1.7rem 0 .8rem;
    }
    .sy-wrap .box{
        position: absolute;
    }
    .sy-wrap .xian1{
        position: absolute;
        top: .46rem;
        left: 3.2rem;
        width: 1.96rem;
        height: 1.24rem;
    }
    .sy-wrap .box1{
        top: .66rem;
        left: 2rem;
        width: 2.88rem;
        height: 1.24rem;
        text-align: center;
    }
    .sy-wrap .xian2{
        position: absolute;
        top: 1.7rem;
        right: 2rem;
        width: 1.84rem;
        height: .74rem;
    }
    .sy-wrap .box2{
        top: 1.8rem;
        right: .6rem;
        z-index: 99;
        width: 3rem;
        text-align: center;
    }
    .sy-wrap .xian3{
        position: absolute;
        top: 4rem;
        left: 2rem;
        width: .82rem;
        height: .64rem;
    }
    .sy-wrap .box3{
        top: 4.56rem;
        left: .8rem;
        text-align: center;
    }
    .sy-wrap .box3 .num{
        text-align: center;
    }
    .sy-wrap .xian4{
        position: absolute;
        top: 4.06rem;
        right: 1.2rem;
        width: .62rem;
        height: .58rem;
    }
    .sy-wrap .box4{
        top: 4.76rem;
        right: .52rem;
    }
    .sy-wrap .box4 .num{
        text-align: center;
    }
    .sy-wrap .box .title{
        /* width: 2rem; */
        padding-top: .14rem;
        color: #3D788C;
        font-size: .36rem;
    }
    .sy-wrap .box3 .title{
        width: 2.4rem;
    }
    .sy-wrap .box .num{
        padding-top: .2rem;
        color: #00BEFF;
        font-size: .52rem;
    }
    .sy-wrap .box1 .num{
        text-align: center;
    }
    .sy-wrap .sy-box{
        position: relative;
        height: 4.35rem;
        text-align: center;
    }
    .sy-wrap .sy-box .bg1{
        position: absolute;
        left: 50%;;
        top: 0;
        width: 4.35rem;
        height: 4.35rem;
        margin-left: -2.18rem;
        animation: turn 10s linear infinite;
    }
    @keyframes turn {
        0% {
            transform: rotate(360deg);
        }

        20% {
            transform: rotate(270deg);
        }

        40% {
            transform: rotate(180deg);
        }

        60% {
            transform: rotate(90deg);
        }

        80% {
            transform: rotate(45deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }
    .alert-right-mask,.alert-left-mask{
       animation: showLoad .35s linear;
    }
    @keyframes showLoad {
        0% {
          width: 1rem;
          height: 20%;
          opacity: .2;
        }
        30% {
          width: 3rem;
          height: 40%;
          opacity: .4;
        }
        60% {
          width: 6rem;
          height: 70%;
          opacity: .6;
        }
        100% {
          width: 7.34rem;
          height: 100%;
          opacity: 1;
        }
    }
    .sy-wrap .sy-box .bg2{
        position: absolute;
        top: .3rem;
        left: 50%;
        width: 3.82rem;
        height: 3.82rem;
        margin-left: -1.9rem;
        animation: turn2 9s linear infinite;
    }
    @keyframes turn2 {
        0% {
            transform: rotate(0deg);
        }

        20% {
            transform: rotate(72deg);
        }

        40% {
            transform: rotate(144deg);
        }

        60% {
            transform: rotate(216deg);
        }

        80% {
            transform: rotate(288deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    .sy-wrap .sy-box .t1{
        position: relative;
        z-index: 99;
        width: 4.35rem;
        margin: auto;
        padding-top: 1.2rem;
        color: #6698C9;
        font-size: .22rem;
    }
    .sy-wrap .sy-box .money{
        position: relative;
        z-index: 99;
        padding-top: .3rem;
        color: #4AD1FF;
        font-size: .7rem;
    }
    .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .2rem .5rem .38rem;
    }
    .tab-box .tab{
        position: relative;
        width: 4.2rem;
        height: .78rem;
        color: #589AB0;
        font-size: .42rem;
        line-height: .78rem;
        text-align: center;
    }
    .tab-box .tab.active{
        color: #67C5E5;
        background: url('../assets/choise.png') no-repeat center center;
        background-size: 100% 100%;
    }
    .tips-bg{
        height: .44rem;
        margin: .5rem .38rem .3rem .34rem;
        color: #67C5E5;
        font-size: .22rem;
        line-height: .44rem;
        background: url('../assets/element.png') no-repeat right center;
        background-size: cover;
    }
    .ul-box{
        padding: .5rem .32rem .3rem;
    }
    .ul-box .list{
        position: relative;
        margin-bottom: .34rem;
        padding: .34rem .1rem .3rem 0;
        /* background: rgba(4,9,37,.6);         */
    }
    .ul-box .list .border{
        position: absolute;
    }
    .ul-box .list .border1{
        left: 0;
        top: 0;
        width: .38rem;
        height: .32rem;
        border-top: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border2{
        top: 0;
        right: 0;
        width: .38rem;
        height: .32rem;
        border-top: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list .border3{
        left: 0;
        bottom: 0;
        width: .38rem;
        height: .32rem;
        border-bottom: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border4{
        right: 0;
        bottom: 0;
        width: .38rem;
        height: .32rem;
        border-bottom: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list-head{
        display: flex;
        align-items: center;
        padding: 0 0 .26rem .1rem;
        border-bottom: 1px solid #858585;
    }
    .ul-box .list .img{
        width: 1rem;
        /* height: 1.25rem; */
    }
    .ul-box .list .info-box{
        flex: 1;
        margin-left: .2rem;
        color: #cecece;
        font-size: .24rem;
    }
    .ul-box .list .info-box .title{
        color: #fff;
        font-size: .28rem;
    }
    .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .3rem;
    }
    .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        margin-top: .18rem;
    }
    .ul-box .list .info-box .text1{
        flex: 1.5;
    }
    .ul-box .list .info-box .text2{
        flex: 1;
    }
    .list-foot{
        padding: .3rem .26rem 0;
        color: #cecece;
        font-size: .24rem;
    }
    .list-foot .item{
        margin-bottom: .12rem;
    }
    .list-foot .item .num{
        color: #2CAADE;
    }
    .list-foot .item:last-child{
        margin-bottom: 0;
    }
    .list-foot .item.blue{
        color: #00BEFF;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .12rem .22rem;
        color: #fff;
        font-size: .24rem;
        background: rgba(44, 170, 222,.2);
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{
        background: rgba(157, 157, 157,.2);
    }
    .status .icon{
        margin-left: .1rem;
        width: .28rem;
        height: .28rem;
    }
    .item-ul{
      margin: .2rem 0;
    }
    .item-ul .item-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem;
    }
    .item-ul .item-li .item-left{
      display: flex;
      align-items: center;
    }
    .item-ul .item-li .item-left .icon{
      width: .52rem;
    }
    .item-ul .item-li .item-left .text{
      margin-left: .28rem;
      color: #fff;
      font-size: .48rem;
    }
     .item-ul .item-li .arrow{
       width: .18rem;
     }
    .alert-sh-wrap{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: rgbA(26, 36, 64,.9);
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-sh-wrap .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-sh-wrap .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-sh-wrap .cont{
        max-height: 6rem;
        padding: 0 .4rem .72rem .4rem;
        color: #fff;
        font-size: .28rem;
        overflow: auto;
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .28rem 0 .5rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .3rem;
        height: .3rem;
    }
    .alert-wrap2{
        position: absolute;
        left: .72rem;
        right: .72rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        /* background: #1A2440; */
        background: rgba(26, 36, 64,.8);
        border-radius: .2rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .tips{
        padding: 0 .44rem .44rem;
        color: #D1D1D1;
        font-size: .24rem;
    }
    .alert-wrap2 .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem .44rem .64rem;
    }
    .alert-wrap2 .input-box .input{
        width: 2rem;
        height: .7rem;
        color: #fff;
        font-size: .28rem;
        background: #405692;
        border-radius: .06rem;
        text-align: center;
    }
    .alert-wrap2 .input-box .line{
        width: .28rem;
        height: 1px;
        background: #fff;
    }
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: .9rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .2rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .2rem 0;
    }
    .alert-wrap2 .xys-box{
        padding: 0 .5rem .48rem;
    }
    .alert-wrap2 .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .16rem .08rem;
        font-size: .32rem;
        border-bottom: 1px solid #484e5e;
    }
    .alert-wrap2 .list .time{
        color: #777981;
    }
    .alert-wrap2 .list .num{
        color: #2CAADE;
    }
    .alert-cont-box{
        height: 7.6rem;
        overflow-y: auto;
    }
    .alert-box{
        position: absolute;
        left: .5rem;
        right: .5rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        padding: .26rem .46rem .68rem .46rem;
        background: rgba(55, 76, 124,.9);
        border-radius: .1rem;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .alert-box .alert-head{
        position: relative;
        padding: 0 .06rem;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-box .close{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .36rem;
        height: .36rem;
    }
    .alert-box .pwd-box{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: .5rem;
        border: 1px solid #fff;
    }
    .alert-box .pwd-box .pwd{
        flex: 1;
        height: 1rem;
    }
    .alert-box .pwd-box .pwd .input{
        width: 100%;
        height: 1rem;
        color: #fff;
        font-size: .52rem;
        font-weight: bold;
        border-right: 1px solid #fff;
        background: #374C7C;
        text-align: center;
        border-radius: 0;
        outline: none;
        box-sizing: border-box;
    }
    .alert-box .pwd-box .pwd:last-child .input{
        border-right: none;
    }
    .assets-wrap{
        position: relative;
        height: 4.68rem;
        margin: 0 .3rem .24rem;
    }
    .assets-wrap .user-bg{
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 4.68rem;
    }
    .assets-wrap .assets-box{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        padding: .52rem .92rem .56rem;
        color: #fff;
        box-sizing: border-box;
    }
    .assets-wrap .assets-box .arrow{
      position: absolute;
      top: .5rem;
      right: .4rem;
      width: .25rem;
    }
    .assets-wrap .assets-box .text{
      font-size: .42rem;
    }
    .assets-wrap .assets-box .money{
      padding-top: .4rem;
      font-size: .56rem;
    }
    .assets-wrap .assets-box .small{
      font-size: .36rem;
    }
    .assets-wrap .assets-foot{
      position: absolute;
      left: 0;
      right: 0;
      top: 2.5rem;
      z-index: 1;
      display: flex;
      align-items: center;
      color: #fff;
      padding: 0 .92rem .56rem;
    }
     .assets-wrap .assets-foot .assets-item{
       width: 50%;
     }
     .assets-wrap .assets-foot .assets-item:first-child{
       border-right: 1px solid #fff;
     }
     .assets-wrap .assets-foot .assets-item:last-child{
       padding-left: .8rem;
     }
    .assets-wrap .assets-foot .t1{
      font-size: .42rem;
    }
    .assets-wrap .assets-foot .t2{
      padding-top: .4rem;
      font-size: .56rem;
    }
    .assets-wrap .assets-foot .small{
      font-size: .36rem;
    }
    .cont-box .table-head{
        display: flex;
        align-items: center;
        padding: .4rem .32rem 0;
    }
    .cont-box .table-head .th{
        width: 33.33%;
        color: #7f7f7f;
        font-size: .4rem;
    }
    .cont-box .table-body{
        padding: 0 .4rem;
    }
    .cont-box .table-body .tr{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .4rem 0;
        border-bottom: 1px solid #313a47;
    }
    .cont-box .table-body .tr .item{
        width: 33.33%;
    }
    .cont-box .table-body .coin{
        display: flex;
        align-items: center;
    }
    .cont-box .table-body .coin .icon{
        width: .94rem;
        height: .94rem;
        margin-right: .3rem;
        border-radius: 50%;
    }
    .cont-box .table-body .coin .t1{
        color: #fff;
        font-size: .38rem;
    }
    .cont-box .table-body .coin .t2{
        color: #b0b0b0;
        font-size: .32rem;
    }
    .cont-box .table-body .price{
        color: #fff;
        font-size: .48rem;
    }
    .cont-box .table-body .change .persent{
        display: inline-block;
        width: 2rem;
        padding: 6px;
        color: #fff;
        font-size: .36rem;
        border-radius: 4px;
        background: #00c483;
        text-align: center;
    }
    .cont-box .notice-box{
        display: flex;
        align-items: center;
        height: 1rem;
        padding: 0 .44rem;
        overflow: hidden;
    }
    .cont-box .notice-box .icon{
        width: .6rem;
    }
    .cont-box .notice-box .notice{
        flex: 1;
        height: 1rem;
        padding: 0 .4rem;
        line-height: 1rem;
        overflow: hidden;
    }
    .cont-box .notice-box .notice .swiper-container{
        height: 1rem;
    }
    .cont-box .notice-box .notice .text{
        color: #fff;
        font-size: .4rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .cont-box .notice-box .arrow{
      width: .25rem;
    }
    .cont-box .banner-wrap{
      height: 3.92rem;
      margin: 0 .44rem;
    }
    .cont-box .banner-wrap .banner-box{
      height: 100%;
    }
    .cont-box .banner-box .img{
      width: 100%;
      height: 3.92rem;
      border-radius: .2rem;
    }
    .cont-box .coin-box{
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        margin: .3rem .32rem 0;
        overflow-x: scroll;
    }
    .cont-box .coin-box .coin-li{
        padding: .2rem .3rem .16rem;
        text-align: center;
    }
    .cont-box .coin-box .coin-head{
        display: flex;
        align-items: center;
    }
    .cont-box .coin-box .coin-head .icon{
        width: .59rem;
        height: .59rem;
    }
    .cont-box .coin-box .coin-head .text{
        color: #fff;
        font-size: .35rem;
        padding-left: .2rem;
    }
    .cont-box .coin-box .coin-head .text .t1{
        color: #b0b0b0;
    }
    .cont-box .coin-box .price{
        padding: .3rem 0 .2rem;
        color: #fff;
        font-size: .48rem;
    }
    .cont-box .coin-box .change{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #49d674;
        font-size: .36rem;
    }
    .cont-box .coin-box .change .arrow{
        height: .8rem;
        margin-right: .1rem;
    }
     .cont-box .coin-box .change .arrow.die{
         transform: rotate(180deg);
     }
    .mask-notice{
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 11;
      background-color: rgba(0, 0, 0, 0.5);
   }
   /* 公告弹窗 */
    .notice-wrap{
        position: fixed;
        left: 5%;
        right: 5%;
        top: 50%;
        z-index: 12;
        width: 90%;
        padding: 0 6px;
        border-radius: 4px;
        background: #0e1530;
        box-sizing: border-box;
        transform: translateY(-50%);
    }
    .notice-wrap .title{
        padding: .3rem;
        color: #fff;
        font-size: .45rem;
        text-align: center;
    }
    .notice-wrap .cont{
        min-height: 2.4rem;
        max-height: 6rem;
        padding: .3rem;
        color: #ccc;
        font-size: .36rem;
        word-break: break-word;
        overflow-y: scroll;
    }
    .notice-wrap .notice-btn{
        height: 1rem;
        margin: .3rem .3rem .6rem;
        line-height: 1rem
    }
    .notice-wrap .btn-close{
        position: absolute;
        right: .3rem;
        top: .3rem;
        width: .4rem;
    }
    /* 右侧弹窗 */
    .alert-right-mask{
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      width: 7.34rem;
      height: 100%;
      padding: .7rem .54rem .5rem .6rem;
      background: #1b2349;
      box-sizing: border-box;
      overflow-y: scroll;
    }
    .alert-left-mask .close,.alert-right-mask .close{
      display: block;
      width: .5rem;
      margin-left: auto;
      margin-bottom: .25rem;
    }
    .alert-right-mask .alert-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .54rem 0;
      border-bottom: 1px solid #2d324b;
    }
    .alert-right-mask .alert-li .title{
      color: #fff;
      font-size: .4rem;
    }
    .alert-right-mask .alert-li .arrow{
      width: .18rem;
    }
    .alert-right-mask .alert-li2{
      justify-content: center;
    }
    /* 左侧弹窗 */
    .alert-left-mask{
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 1000;
      width: 7.28rem;
      height: 100%;
      padding: .5rem .54rem .5rem;
      background: #1b2349;
      box-sizing: border-box;
      overflow-y: scroll;
    }
    .alert-left-mask .alert-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: .5rem;
    }
    .alert-left-mask .alert-head .user{
      width: 1rem;
      height: 1rem;
      margin-right: .24rem;
      border-radius: 50%;
    }
    .alert-left-mask .alert-head .address-box{
      flex: 1;
    }
    .alert-left-mask .alert-head .address-box .address{
      color: #fff;
      font-size: .4rem;
    }
    .alert-left-mask .alert-head .address-box .uid{
      margin-top: .28rem;
      color: #fff;
      font-size: .3rem;
    }
    .alert-left-mask .alert-head .copy{
      width: .5rem;
    }
    .alert-left-mask .alert-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .5rem 0;
    }
    .alert-left-mask .alert-li .title{
      display: flex;
      align-items: center;
    }
    .alert-left-mask .alert-li .title .icon{
      width: .55rem;
    }
    .alert-left-mask .alert-li .title .text{
      padding-left: .28rem;
      color: #fff;
      font-size: .4rem;
    }
    .alert-left-mask .alert-li .arrow{
      width: .18rem;
    }
    .tab-box2{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: .42rem 0;
    }
    .tab-box2 .tab2{
      position: relative;
      padding: 0 .5rem;
      color: #fff;
      font-size: .52rem;
    }
    .tab-box2 .tab2.active::after{
      position: absolute;
      left: 50%;
      bottom: -.2rem;
      content: '';
      width: .78rem;
      height: .06rem;
      background: #2d66cf;
	    border-radius: 0.03rem;
      transform: translateX(-50%);
    }
    /* 登录弹窗 */
    .alert-login-box{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      background: #0a1225;
    }
    .alert-login-box .alert-head-box{
      display: flex;
      align-items: center;
      padding: .85rem .48rem .5rem;
      border-bottom: 1px solid #2b3346;
    }
    .alert-login-box .logo{
      width: 1.56rem;
      height: 1.56rem;
      margin-right: .46rem;
    }
    .alert-login-box .alert-head-box .alert-title{
      color: #fff;
      font-size: .56rem;
      font-weight: 600;
    }
    .alert-login-box .alert-head-box .alert-url{
      padding-top: .28rem;
      color: #3d92d4;
      font-size: .4rem;
      font-weight: 600;
    }
    .alert-login-box .alert-tips{
      padding: .38rem .5rem .6rem;
      color: #a2aabd;
      font-size: .45rem;
    }
    .alert-login-box .input-box{
      height: 1.5rem;
      margin: 0 .5rem;
      background: #1c273c;
      border-radius: 0.2rem;
    }
    .alert-login-box .input-box .input{
      width: 100%;
      height: 1.5rem;
      padding: 0 .45rem;
      color: #fff;
      font-size: .42rem;
      line-height: 1.5rem;
      box-sizing: border-box;
    }
    .alert-login-box .input-box .input::placeholder{
      color: #5d6b8f;
      font-size: .48rem;
    }
    .alert-login-box .alert-btn-box{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: .96rem .5rem .75rem;
    }
    .alert-login-box .alert-ul-box{
      margin: 0 .5rem;
    }
    .alert-login-box .alert-ul-box2{
      border-bottom: 1px solid #313a47;
    }
    .alert-login-box .alert-ul-box .alert-li{
      display: flex;
      align-items: center;
      padding: .4rem 0;
    }
    .alert-login-box .alert-ul-box .alert-li .icon{
      width: .64rem;
      height: .64rem;
      margin-right: .5rem;
    }
    .alert-login-box .alert-ul-box.alert-ul-box2 .alert-li{
      align-items: stretch;
    }
    .alert-login-box .alert-ul-box.alert-ul-box2 .alert-li .icon{
      width: 1rem;
      height: 1rem;
      margin-right: .14rem;
    }
    .alert-login-box .alert-ul-box .alert-li .t1{
      color: #a2aabd;
      font-size: .42rem;
    }
    .alert-login-box .alert-ul-box .alert-li .t2{
      display: flex;
      align-items: center;
      margin-top: .3rem;
      color: #fff;
      font-size: .42rem;
    }
     .alert-login-box .alert-ul-box .alert-li .t2 .img{
       width: .48rem;
       margin-right: .2rem;
     }
    .alert-login-box .alert-btn-box .alert-btn{
      flex: 1;
      height: 1.32rem;
      color: #fff;
      font-size: .4rem;
      line-height: 1.32rem;
      background: #1099f9;
      border-radius: 0.2rem;
      text-align: center;
    }
    .alert-login-box .alert-btn-box .alert-btn.btn-jj{
      margin-right: .58rem;
      background: #161f30;
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue